import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { UrlParamsService } from '@app/core';

@Component({
  selector: 'app-taxonomy',
  templateUrl: './taxonomy.component.html',
  styleUrls: ['./taxonomy.component.scss'],
  standalone: false
})
export class TaxonomyComponent {
  @Input() mainTitle: string;
  @Input() allowSearch = false;
  @Input() isSearchOpen = false;
  @Input() isMenuMobileOpen = false;
  @Output() isSearchOpenChange = new EventEmitter<boolean>();

  constructor(public urlParamsService: UrlParamsService) {}

  @HostListener('window:resize') private onResize() {
    if (window.innerWidth <= 991 && this.isSearchOpen) {
      this.isSearchOpen = false;
      this.isSearchOpenChange.emit(this.isSearchOpen);
    }
  }
}
